import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c134eb94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "日本男篮世预赛最终名单点评"),
  /*#__PURE__*/_createElementVNode("div", { class: "sub_title" }, "中国篮协技战术服务平台")
], -1))
const _hoisted_3 = { class: "group" }
const _hoisted_4 = { class: "group-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divide" }, null, -1))
const _hoisted_6 = { class: "players" }
const _hoisted_7 = { class: "head-pic" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "player-name" }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = {
  class: "info-item",
  style: {"margin-top":"5px"}
}
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "view-zrdp" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "japan-reports-final/阵容搭配.html" }, "查看球队阵容搭配")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (position) => {
      return (_openBlock(), _createElementBlock("div", {
        key: position.title
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(position.title), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.data, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "player",
              key: item.playerName
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  class: "img",
                  src: item.pic,
                  alt: ""
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.playerName), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString('号码：' + item.num + '号'), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString('年龄：' + item.age + '岁'), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString('身高：' + item.height + '厘米'), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString('体重：' + item.weight + '公斤'), 1)
              ]),
              _createElementVNode("div", {
                class: "button",
                onClick: ($event: any) => (_ctx.viewDetail(item))
              }, "查看", 8, _hoisted_15)
            ]))
          }), 128))
        ])
      ]))
    }), 128)),
    _hoisted_16
  ]))
}